import React, { useRef, useState } from 'react';
import { Modal, Form, Button } from 'react-bootstrap';
import { Formik } from 'formik';
import * as yup from 'yup';
//Axios
import clienteAxios from '../../../../../config/axios';
//Redux
import { useDispatch } from 'react-redux';
import { updateSessionUrlAction } from '../../../../../actions/audiencesActions';
import ButtonSpinner from '../../../../layout/ButtonSpinner';
import { ICON_SAVE, ICON_CANCEL } from '../../../../extras/icons';
//Función principal
const SessionEditForm = props => {
    //Tomo los props
    const { show, handleClose, audience } = props;
    //Genero los refs
    const refSession = useRef();
    //Inicializo el dispatch
    const dispatch = useDispatch();
    //Inicializo los datos
    const initialData = {
        sessionUrl: audience && audience.sessionUrl ? audience.sessionUrl : ''
    }
    //Inicializo el state local
    const [loading, setLoading] = useState(false);
    //Manejo cuando se muestra
    const handleOnShow = e => {
        //Pongo el foco en el primer campo
        refSession.current.focus();
    }
    //Manejo el guardado
    const handleSave = async values => {
        //Armo los datos
        const data = {
            sessionUrl: values.sessionUrl
        }
        //Llamo al dispatch
        dispatch( updateSessionUrlAction(audience, data, handleClose) );
    }
    //Esquema de validación
    const validationSchema = yup.object({
        sessionUrl: yup.string().url().required()
    });
    //Renderizo
    return (
        <Modal
            show={show} 
            onHide={handleClose} 
            onShow={handleOnShow} 
            aria-labelledby="contained-modal-title-vcenter" 
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title>
                    <strong>Editar Enlace remoto</strong> <small>(Audiencia #{ audience && audience.id })</small>
                </Modal.Title>
            </Modal.Header>
            <Formik
                enableReinitialize
                validationSchema={validationSchema}
                initialValues={{ ...initialData }}
                onSubmit={ values => handleSave(values) }
            >
                {({
                    handleSubmit,
                    handleChange,
                    handleBlur,
                    values,
                    touched,
                    isValid,
                    errors,
                    isSubmitting
                }) => (
                    <form noValidate onSubmit={handleSubmit} autoComplete="off">
                        <Modal.Body>
                            <div className="row">
                                <div className="col-12">
                                    <div className="alert alert-info">
                                        Indique la URL del enlace remoto para acceder a la audiencia.
                                    </div>
                                </div>
                                <Form.Group className="col-md-12">
                                    <Form.Control
                                        id="sessionUrl"
                                        className="form-control" 
                                        autoFocus 
                                        name="sessionUrl" 
                                        type="text" 
                                        placeholder="Ingrese URL de enlace remoto"
                                        value={ values.sessionUrl }
                                        onChange={handleChange}
                                        ref={refSession}
                                        isInvalid={!!errors.sessionUrl}
                                        disabled={ loading }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        { errors.sessionUrl }
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            {
                                loading ? (
                                    <ButtonSpinner />
                                ) : (
                                    <Button variant="success" type="submit" disabled={ loading }>
                                        <ICON_SAVE /> <strong>ACTUALIZAR</strong>
                                    </Button>
                                )
                            }
                            <Button variant="secondary" onClick={handleClose} disabled={ loading }>
                                <ICON_CANCEL /> Cancelar
                            </Button>
                        </Modal.Footer>
                    </form>
                )}
            </Formik>
        </Modal>
    );
};

export default SessionEditForm;